var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovieVideosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "movie-videos-icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83.602,
    height: 65.171,
    viewBox: "0 0 83.602 65.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009ffd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2a72"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_68680",
    "data-name": "Path 68680",
    d: "M8.259,0H75.342A8.269,8.269,0,0,1,83.6,8.259V56.884a8.269,8.269,0,0,1-8.259,8.259H62.279a1.889,1.889,0,0,1-.347.027,1.988,1.988,0,0,1-.347-.027h-18.9a1.889,1.889,0,0,1-.347.027,1.988,1.988,0,0,1-.347-.027H22.663a1.889,1.889,0,0,1-.347.027,1.988,1.988,0,0,1-.347-.027H8.259A8.269,8.269,0,0,1,0,56.884V8.259A8.269,8.269,0,0,1,8.259,0ZM37.549,21.254,51.516,31a1.99,1.99,0,0,1,.068,3.313L37.671,43.93a1.992,1.992,0,0,1-3.252-1.544V22.88h.007a1.982,1.982,0,0,1,3.123-1.626Zm26.37,32.8v7.11H75.335a4.3,4.3,0,0,0,4.279-4.279v-2.83Zm-3.98,7.11v-7.11H44.332v7.11Zm-19.587,0v-7.11H24.309v7.11Zm-20.03,0v-7.11H3.98v2.83a4.3,4.3,0,0,0,4.279,4.279ZM3.98,50.074H79.622V15.1H3.98v34.97Zm55.959-38.95V3.98H44.332v7.137H59.939Zm3.98-7.144v7.137h15.7V8.259A4.3,4.3,0,0,0,75.335,3.98H63.919ZM40.352,11.124V3.98H24.309v7.137H40.352Zm-20.03,0V3.98H8.259A4.3,4.3,0,0,0,3.98,8.259v2.857H20.322Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieVideosIcon);
export default __webpack_public_path__ + "static/media/movie-videos-icon.2fea91a4cf6f1afb8debc3754991f03f.svg";
export { ForwardRef as ReactComponent };